module.exports = __webpack_public_path__ + "static/media/02fa-standard.b2c3b91e.png";